export const handleQuestionsInitialAdjustments = (
  questionnaire,
  endorsementType
) => {
  return questionnaire.map(question => {
    if ([1438].includes(question.idQuestion)) {
      question.behaviorObject.isRequired = questionnaire.find(question => question.idQuestion === 171)?.idAnswerOption === 1166;
      const feeDimension = question.childrenQuestions?.find(question => question.idQuestion === 1512);
      const { defaultValue } = feeDimension?.behaviorObject || {};

      for (const q of question.childrenQuestions || []) {
        q.visibleQuestion = true;
        q.behaviorObject.isRequired = questionnaire.find(question => question.idQuestion === 171)?.idAnswerOption === 1166;

        if (q.idQuestion === 1440 || q.idQuestion === 1510) {
          q.behaviorObject.isRequired = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7089 : defaultValue === 7089;
          q.visibleQuestion = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7089 : defaultValue === 7089;
        }

        if (q.idQuestion === 1441) {
          q.behaviorObject.isRequired = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7090 : defaultValue === 7090;
          q.visibleQuestion = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7090 : defaultValue === 7090;
        }
      }

      for (const q of questionnaire) {
        const feeDimension = question.childrenQuestions?.find(question => question.idQuestion === 1512) || questionnaire.find(question => question.idQuestion === 1512);
        const { defaultValue } = feeDimension?.behaviorObject || {};

        if (q.idQuestion === 1440 || q.idQuestion === 1510) {
          q.behaviorObject.isRequired = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7089 : defaultValue === 7089;
          q.visibleQuestion = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7089 : defaultValue === 7089;
        }

        if (q.idQuestion === 1441) {
          q.behaviorObject.isRequired = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7090 : defaultValue === 7090;
          q.visibleQuestion = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7090 : defaultValue === 7090;
        }
      }
    }

    if (question.idQuestion === 1464) {
      question.disabled = true;
    }

    if (question.idQuestion === 1796 && question.idAnswerOption) {
      questionnaire.map(qst => {
        if (qst.idQuestion === 1797) {
          qst.behaviorObject.administeredByAnswer = question.idAnswerOption || null;  
        }  
        return qst;
      })
    }

    if (question.idQuestion === 1796 && question.idAnswerOption) {
      questionnaire.map(qst => {
        if (qst.idQuestion === 1797) {
          qst.behaviorObject.administeredByAnswer = question.idAnswerOption || null;  
        }  
        return qst;
      })
    }

    if ([1444].includes(question.idQuestion)) {
      question.behaviorObject.isRequired = questionnaire.find(question => question.idQuestion === 175)?.idAnswerOption === 6893;
      const deductionDimension = question.childrenQuestions?.find(question => question.idQuestion === 1513);
      const { defaultValue } = deductionDimension?.behaviorObject || {};

      for (const q of question.childrenQuestions || []) {
        q.visibleQuestion = true;
        q.behaviorObject.isRequired = questionnaire.find(question => question.idQuestion === 175)?.idAnswerOption === 6893;

        if (q.idQuestion === 1445 || q.idQuestion === 1511) {
          q.behaviorObject.isRequired = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7091 : defaultValue === 7091;
          q.visibleQuestion = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7091 : defaultValue === 7091;
        }

        if (q.idQuestion === 1446) {
          q.behaviorObject.isRequired = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7092 : defaultValue === 7092;
          q.visibleQuestion = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7092 : defaultValue === 7092;
        }
      }

      for (const q of questionnaire) {
        const deductionDimension = questionnaire.find(question => question.idQuestion === 1513);
        const { defaultValue } = deductionDimension?.behaviorObject || {};

        if (q.idQuestion === 1445 || q.idQuestion === 1511) {
          q.behaviorObject.isRequired = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7091 : defaultValue === 7091;
          q.visibleQuestion = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7091 : defaultValue === 7091;
        }

        if (q.idQuestion === 1446) {
          q.behaviorObject.isRequired = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7092 : defaultValue === 7092;
          q.visibleQuestion = deductionDimension?.idAnswerOption ? deductionDimension?.idAnswerOption === 7092 : defaultValue === 7092;
        }
      }
    }



    if ([1433].includes(question.idQuestion)) {
      const tax = questionnaire.find(question => question.idQuestion === 1464);

      for (const q of tax.childrenQuestions) {
        if (q.idQuestion === 1796 || q.idQuestion === 1797) {
          q.behaviorObject.isRequired = question.idAnswerOption === 7012;
          q.visibleQuestion = question.idAnswerOption === 7012;
        }
      }
    }


    if ([1468].includes(question.idQuestion)) {
      const arrayCountries = [1479, 1470, 1392, 1441, 1304, 1277, 2321];
      const regulatoryRiskLocation = questionnaire.find(question => question.idQuestion === 176)?.idAnswerOption;

      question.behaviorObject.countryName = questionnaire.find(question => question.idQuestion === 176)?.answer;
      question.visibleQuestion = arrayCountries.includes(regulatoryRiskLocation) ? true : false;

      if (!arrayCountries.includes(regulatoryRiskLocation)) {
        question.answer = "";
        question.idAnswerOption = null;

      }
    }

    if([2080].includes(question.idQuestion)) {
      if(endorsementType !== 'declaration') { 
        question.behaviorObject.isRequired = false;
        question.visibleQuestion = false;
      }
    }

    return question;
  })
}


export const handleQuestionChange = (
  question,
  value,
  filteredQuestionnaire,
  setFilteredQuestionnaire,
  setFieldValue,
  questionnaire,
  setPeriodicityText,
  setCurrentModality
) => {
  let saveFilteredQuestionnaire = false;


  if (question.idQuestion === 171) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;

    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if ([1438, 1439, 1440, 1441, 1442].includes(qst.idQuestion)) {
        qst.visibleQuestion = idAnswerOption === 1166;
        qst.behaviorObject.isRequired = idAnswerOption === 1166;
      }

      return qst;
    })
  }

  if (question.idQuestion === 175) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;

    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if ([1444, 1445, 1446, 1447, 1448, 1449, 1450].includes(qst.idQuestion)) {
        qst.visibleQuestion = idAnswerOption === 6893;
        qst.behaviorObject.isRequired = idAnswerOption === 6893;
      }

      return qst;
    })
  }

  if (question.idQuestion === 176) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    const arrayCountries = [1479, 1470, 1392, 1441, 1304, 1277, 2321];

    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if ([1468].includes(qst.idQuestion)) {
        qst.behaviorObject.countryName = value;
        qst.visibleQuestion = arrayCountries.includes(idAnswerOption) ? true : false;

        if (!arrayCountries.includes(idAnswerOption)) {
          qst.answer = "";
          qst.idAnswerOption = null;
          setFieldValue && setFieldValue(qst.key, "");
        }
      }

      return qst;
    })
  }


  // Fee Dimension
  if (question.idQuestion === 1512) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;

    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      // 1440 - Amount
      if (qst.idQuestion === 1440 || qst.idQuestion === 1510) {
        qst.visibleQuestion = idAnswerOption === 7089; // 7089 Amount
        qst.behaviorObject.isRequired = idAnswerOption === 7089;
      }

      // 1441 - Percentage
      if (qst.idQuestion === 1441) {
        qst.visibleQuestion = idAnswerOption === 7090; // 7090 Percentage
        qst.behaviorObject.isRequired = idAnswerOption === 7090; // 7090 Percentage
      }

      return qst;
    })
  }


  // Deduction Dimension
  if (question.idQuestion === 1513) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;


    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1445 || qst.idQuestion === 1511) { // 1445 - Amount
        qst.visibleQuestion = idAnswerOption === 7091; // 7091 Amount
        qst.behaviorObject.isRequired = idAnswerOption === 7091; // 7091 Amount
      }

      if (qst.idQuestion === 1446) { // 1446 - Percentage
        qst.visibleQuestion = idAnswerOption === 7092;  // 7092 Percentage
        qst.behaviorObject.isRequired = idAnswerOption === 7092; // 7092 Percentage
      }

      return qst;
    })
  }


  if ([1433].includes(question.idQuestion)) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;

    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if ([1796, 1797].includes(qst.idQuestion)) {
        qst.visibleQuestion = idAnswerOption === 7012;
        qst.behaviorObject.isRequired = idAnswerOption === 7012;
      }

      return qst;
    })
  }


  if(question.idQuestion === 1796) {
    filteredQuestionnaire = filteredQuestionnaire.map(qst => {
      if (qst.idQuestion === 1797) qst.behaviorObject.administeredByAnswer = value?.idAnswerOption || null;

      return qst;
    })
  }


  if (saveFilteredQuestionnaire) setFilteredQuestionnaire(filteredQuestionnaire);
}






